import { apiFactory } from '__generated-api__';
import httpClient from 'api/httpClient';

export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;
export const API_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET;

const api = apiFactory(undefined, process.env.REACT_APP_API_BASE_URL, httpClient);

export default api;
